import { useState, useEffect, useRef } from 'react';

export function useTimerHook(friendID) {
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [timeEnd, setTimeEnd] = useState();
    const intervalRef = useRef(null);

    function padDigits(number, digits) {
        return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
    }

    const getTime = (deadline) => {
        const time = deadline.valueOf() - Date.now();
        setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
        setMinutes(Math.floor((time / 1000 / 60) % 60));
        setSeconds(Math.floor((time / 1000) % 60));
    };

  useEffect(() => {
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    intervalRef.current = setInterval(() => getTime(end), 1000);
    return () => {
        clearInterval(intervalRef.current);
    }
  },[]);

    const formattedTimer = `${padDigits(hours,2)}:${padDigits(minutes,2)}:${padDigits(seconds,2)}`;
    return formattedTimer;
}